import BaseApiService from "../BaseApiService";

interface ScanDatasResponse {
	data: {
		sku: string;
		name: string;
		session_id: string;
		device: "ios" | "android" | "other";
	};
	meta: {};
}

export default class ScanDatas extends BaseApiService {
	private static instance: ScanDatas;
	private baseUrl: string;

	private constructor() {
		super();
		this.baseUrl = process.env["REACT_APP_API_URL"]!.concat("/api/scan-datas");
		ScanDatas.instance = this;
	}

	public static getInstance() {
		if (!ScanDatas.instance) return new this();
		return ScanDatas.instance;
	}

	public async add(sku: string, name: string, session_id: string, device: string): Promise<ScanDatasResponse> {
		const path = this.baseUrl;
		try {
			return await this.postRequest(path, { data: { sku, name, session_id, device } }, { Authorization: `Bearer ${process.env["REACT_APP_API_KEY"]}` });
		} catch (err) {
			return this.onError(err);
		}
	}
}
